export default "<div class=\"ad-banner-example\">\r\n    <ng-template libDynamicDataHost></ng-template>\r\n</div>";